import { IonList, IonSelect, IonSelectOption, IonTextarea } from "@ionic/react";
import "./message-body.scss";
import React, { useRef, useState } from "react";
import ReactQuill from "react-quill";
import { Alert } from "react-bootstrap";
import { HotKeys, Handlers, KeyMap } from "react-keyboard";

const MessageBody = (props: {
  id: string;
  value: string | null;
  placeholders: string[];
  richEditor?: boolean;
  charLimit?: number;
  rows?: number;
  onChange: (val: any) => void;
}) => {
  const [isOverLimit, setOverLimit] = useState(
    props.charLimit && (props.value?.length || 0) > props.charLimit
  );

  const placeholderSelect = useRef<HTMLIonSelectElement>(null);

  const onChange = (val: any) => {
    if (props.charLimit) {
      setOverLimit(val.length > props.charLimit);
    }
    props.onChange(val);
  };

  const onPlaceholderSelect = (e: any) => {
    const placeholder = e.detail.value;
    onChange(props.value + placeholder);

    // reposition caret to the end
    const textareaEl = document.getElementById(props.id)?.querySelector("textarea");
    if (textareaEl) {
      setTimeout(() => {
        textareaEl.setSelectionRange(
          textareaEl.textLength,
          textareaEl.textLength
        );
      }, 100);
    }
  };

  const onCtrlDot = (e: any) => {
    placeholderSelect.current!.open();
  };

  const keyMap: KeyMap = {
    ctrlDot: "ctrl+.",
  };

  const handlers: Handlers = {
    ctrlDot: onCtrlDot,
  };

  return (
    <div>
      <HotKeys keyMap={keyMap} handlers={handlers}>
        {props.richEditor ? (
          <ReactQuill
            theme="snow"
            value={props.value || ""}
            onChange={onChange}
          />
        ) : (
          <div>
            <IonTextarea
              id={props.id}
              name={props.id}
              className={
                isOverLimit ? "message-body-warn pl-2" : "message-body pl-2"
              }
              rows={props.rows || 5}
              value={props.value}
              placeholder="Hello {FirstName} this is Sunnybook hospital! Please visit {URL} to fill out the necessary forms"
              onIonChange={(e) => onChange(e.detail.value)}
            ></IonTextarea>
            {isOverLimit && (
              <Alert variant="warning" className="mt-2 mb-0">
                Text messages over {props.charLimit} characters long will be
                split into two or more and might incur additional costs
              </Alert>
            )}
          </div>
        )}
      </HotKeys>
      <IonSelect
        onIonChange={onPlaceholderSelect}
        hidden
        interface="action-sheet"
        ref={placeholderSelect}
        interfaceOptions={{ header: "Select placeholder" }}
      >
        <IonList>
          {props.placeholders.map((p, idx) => {
            return (
              <IonSelectOption key={idx} value={p}>
                {p}
              </IonSelectOption>
            );
          })}
        </IonList>
      </IonSelect>
    </div>
  );
};

export default MessageBody;
